export default function Translations(string) {
  const language = require('./languages/en.json');
  return language[string];
};
